<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.voucherTypeDeletedList.push"
    :is-show-search-input="true"
    search-placeholder="输入代金券类型名称进行搜索"
  >
    <v-column-time value="删除时间" field="del_time"/>
    <v-column-time sortable=""/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>

    <el-table-column label="ID" prop="id"/>
    <el-table-column label="代金券类型名称" prop="voucher_type_name"/>
    <el-table-column label="有效期">
      <template v-slot="{ row }">
        <template v-if="row.expire_mode === 1 && row.fixed_expire_time">
          {{ row.fixed_expire_time | timeToYmdHi }} 过期
        </template>
        <template v-else>{{ row.valid_duration_seconds | formatDuration }}</template>
      </template>
    </el-table-column>
    <el-table-column label="发放方式">
      <template v-slot="{ row }">
        <span v-for="state in findVoucherIssueType(row.issue_type)" :key="state.value">
          {{ state.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="代金券面额（元）">
      <template v-slot="{ row }">{{ row.amount_in_cents | toYuan }}</template>
    </el-table-column>
    <el-table-column label="唯一性" width="120">
      <template v-slot="{ row }">
        <el-tag :type="row.is_unique ? 'warning' : 'success'" size="small">
          {{ row.is_unique ? '每人限领一张' : '可重复拥有' }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="叠加使用" width="90">
      <template v-slot="{ row }">
        <el-tag :type="row.is_stackable ? 'success' : 'warning'" size="small">
          {{ row.is_stackable ? '可叠加' : '不可叠加' }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="使用规则" prop="rule" show-overflow-tooltip min-width="120"/>

    <el-table-column width="210" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.voucherTypeEdit.to(row.id)"/>

        <v-list-button
          name="恢复"
          icon="restore"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="确定要恢复此类型吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`voucher-type-deleted-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.del_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>代金券类型名称</span>
              <span>{{ v.voucher_type_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>有效期</span>
              <span v-if="v.expire_mode === 1 && v.fixed_expire_time">{{ v.fixed_expire_time | timeToYmdHi }} 过期</span>
              <span v-else>{{ v.valid_duration_seconds | formatDuration }}</span>
            </div>
            <div class="list-item-detail">
              <span>发放方式</span>
              <span v-for="state in findVoucherIssueType(v.issue_type)" :key="state.value">
                {{ state.name }}
              </span>
            </div>
            <div class="list-item-detail" v-if="v.issue_type === 4">
              <span>购买课次券</span>
              <span v-if="v.card_ticket_types && v.card_ticket_types.length">
                <template v-for="tt in v.card_ticket_types">{{ tt.card_ticket_type_name }} </template>
              </span>
              <span v-else class="info-color">--</span>
            </div>
            <div class="list-item-detail">
              <span>代金券面额（元）</span>
              <span>{{ v.amount_in_cents | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>唯一性</span>
              <span>{{ v.is_unique ? '每人限领一张' : '可重复拥有' }}</span>
            </div>
            <div class="list-item-detail">
              <span>叠加使用</span>
              <span>{{ v.is_stackable ? '可叠加' : '不可叠加' }}</span>
            </div>
            <div class="list-item-detail" v-if="v.rule">
              <span>使用规则</span>
              <span>{{ v.rule }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button :to="RouteConfig.voucherTypeEdit.to(v.id)"/>
              <v-list-button
                name="恢复"
                icon="restore"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="确定要恢复此类型吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, restore } from '@/api/voucher-type';
import { findVoucherIssueType } from '@/enums/voucherIssueTypes';

export default {
  name: RouteConfig.voucherTypeDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findVoucherIssueType,
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      const { ...params } = queryList;
      params.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id, update_time }) {
      if (this.isDeleting[id]) return;
      if (!id) return this.$message.warning('缺少代金券类型 ID，无法恢复！');
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.warning('缺少代金券类型信息，无法恢复！');

      this.$set(this.isDeleting, id, true);
      const { isError } = await restore(id, update_time);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
